import { Switch } from '@/components/ui/switch'
import {
  useOrgPageViewCapture,
  useUpdateOrgPageViewCapture,
} from '@/hooks/useOrgPageViewCapture'

export function PageViewCaptureSection() {
  const { enabled, isLoading, error } = useOrgPageViewCapture()
  const updateMutation = useUpdateOrgPageViewCapture()

  return (
    <div className="space-y-6">
      <div className="space-y-1.5">
        <h3 className="text-base font-semibold text-card-foreground">
          Page view capture
        </h3>
        <p className="text-sm text-muted-foreground">
          Let agents see which products a shopper browsed before they started
          chatting.
        </p>
      </div>

      {error ? (
        <p className="text-sm text-destructive">
          We could not read your current setting. Reload the page before you
          change it, so you do not switch off capture that is already on.
        </p>
      ) : null}

      <div className="flex items-start justify-between gap-4 rounded-2xl border border-border bg-background p-4 shadow-sm">
        <div className="space-y-0.5">
          <label
            htmlFor="page-view-capture-enabled"
            className="text-sm font-medium text-foreground"
          >
            Capture page views before chat starts
          </label>
          <p className="text-sm text-muted-foreground">
            Off by default. This applies to every agent in your organization.
          </p>
        </div>
        <Switch
          id="page-view-capture-enabled"
          aria-label="Capture page views before chat starts"
          checked={enabled}
          disabled={isLoading || !!error || updateMutation.isPending}
          onCheckedChange={(checked) => updateMutation.mutate(checked)}
        />
      </div>
    </div>
  )
}
